import { api } from "./api";


export const portalsListApi = (params) => {
    return api.get(`/hub/portal/list`, { params: params });
};

export const portalViewApi = (params) => {
    return api.get(`/hub/portal/view`, {
        params: params,
    });
};

export const usersListApi = (params) => {
    return api.get(`/hub/portal/users-list`, { params: params });
};

export const portalCreateApi = (params) => {
    return api.post(`/hub/portal/create`, JSON.stringify(params));
};

export const portalDeleteApi = (params) => {
    return api.post(`/hub/portal/delete`, JSON.stringify(params));
};

export const portalEditApi = (params) => {
    return api.post(`/hub/portal/edit`, JSON.stringify(params));
};

export const glossaryDropDownApi = (params) => {
    return api.get(`/hub/portal/glossary-list`, { params: params });
};

export const addResourcePortalApi = (params) => {
    return api.post(`/hub/portal/add-resource`, JSON.stringify(params));
};

export const addUserPortalApi = (params) => {
    return api.post(`/hub/portal/add-user`, JSON.stringify(params));
};

export const removeUserPortalApi = (params) => {
    return api.post(`/hub/portal/remove-user`, JSON.stringify(params));
};

export const removeGlossaryPortalApi = (params) => {
    return api.post(`/hub/portal/remove-glossary`, JSON.stringify(params));
};